<template lang="pug">
.select-card-container.flex-mid(:class="{ active, loading }", v-if="item")
  template(v-if='!loading')
    .title
      span.num(v-if="item.currentPrice") {{ item.currentPrice }}
      span.desc-title 元{{ item.title }}
      template(v-if="item.num && item.num > 1")
        span.multiple x
        span.pirce {{ item.num }}
        span 张
    .desc(v-if="item.desc") {{ item.desc }}
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.select-card-container {
  display: inline-flex;
  flex-direction: column;
  width: 100%;
  height: 0.6rem;
  background: #fff;
  box-shadow: 0 0.01rem 0.02rem 0 rgba(0, 0, 0, 0.06);
  border-radius: 0.08rem;
  border: 1px solid #dbdbdb;
  overflow: hidden;
  transition: all 0.2s ease;
  position: relative;

  &.loading {
    background: #f0f3f5;
    box-shadow: 0 0.01rem 0.02rem 0 rgba(0, 0, 0, 0.06);
    border-radius: 0.08rem;
    border: none;
  }

  .title {
    font-weight: 500;
    line-height: 0.17rem;
    color: #242729;
    transition: all 0.2s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;

    .num {
      font-size: 0.2rem;
      line-height: 0.28rem;
    }

    .desc-title {
      font-size: 0.12rem;
      line-height: 0.17rem;
    }

    .multiple {
      font-weight: normal;
      margin: 0 0.02rem;
    }

    .pirce {
      font-size: 0.19rem;
      line-height: 0.28rem;
    }
  }

  .desc {
    height: 0.16rem;
    font-size: 0.11rem;
    line-height: 0.16rem;
    color: #5a6066;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 80%;
    position: relative;
    transition: all 0.2s ease;
    font-weight: normal;
  }

  &.active:not(.loading) {
    border-color: #efc36a;
    background: #fffaed;

    .mark {
      opacity: 1;
    }

    .title {
      color: #d5261b;
    }

    .desc {
      color: #8f5c33;
    }
  }
}
</style>
